import * as React from "react";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import {
  Button,
  Checkbox,
  Chip,
  FormControlLabel,
  FormGroup,
  Grid,
  Menu,
  MenuItem,
  TablePagination,
  useMediaQuery,
} from "@mui/material";
import { useState } from "react";
import CustomInput from "./CustomInput";
import CustomButton from "./CustomButton";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CustomChips from "./CustomChips";
import SmsIcon from "@mui/icons-material/Sms";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import PrintIcon from "@mui/icons-material/Print";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import ReceiptIcon from "@mui/icons-material/Receipt";
import { useEffect } from "react";
import RefreshIcon from "@mui/icons-material/Refresh";
import CustomTooltip from "./CustomTooltip";
import { useTheme } from "@emotion/react";
import InsertLinkOutlinedIcon from "@mui/icons-material/InsertLinkOutlined";

function Row(props) {
  const {
    row,
    handleAction,
    collapseTitle,
    isSelectioEnable,
    isSelected,
    handleClick,
    isCollapse,
    innerTableData,
    innerTableHeaders,
    isActionVisible,
    columns,
    index,
    setSelectedData,
    displayColumns,
  } = props;
  const [open, setOpen] = useState(false);

  const isRowSelected = isSelected(row.id);
  const dummyImageUrl = "https://picsum.photos/50/50"; // Replace with actual dummy image URL

  const getImageUrl = (url) => {
    return !url || url === "N/A" ? dummyImageUrl : url?.props?.src;
  };

  const copyToClipboard = (url) => {
    navigator.clipboard.writeText(url).then(() => {
      alert("LinkedIn URL copied to clipboard!");
    });
  };

  return (
    <React.Fragment>
      <TableRow
        key={row.id}
        sx={{ "& > *": { borderBottom: "unset" } }}
        selected={isSelectioEnable ? isRowSelected : false}
      >
        {isSelectioEnable && (
          <TableCell
            sx={{ borderBottom: 0 }}
            component="th"
            scope="row"
            padding="checkbox"
          >
            <Checkbox
              onClick={(event) =>
                isSelectioEnable ? handleClick(event, row.id) : null
              }
              checked={isRowSelected}
            />
          </TableCell>
        )}
        {isCollapse && (
          <TableCell>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>
        )}
        {displayColumns.map((column, index) => {
          if (column.id === "image_url") {
            return (
              <TableCell key={index} component="th" scope="row">
                <img
                  src={getImageUrl(row[column.id])}
                  alt="Profile"
                  style={{ width: 50, height: 50, borderRadius: "50%" }}
                />
              </TableCell>
            );
          }

          if (column.id === "linkedin_url") {
            const isDisabled = !row[column.id] || row[column.id] === "N/A";
            return (
              <TableCell key={index} component="th" scope="row">
                <IconButton
                  onClick={() =>
                    !isDisabled && copyToClipboard(row[column.id]?.props?.href)
                  }
                  disabled={isDisabled}
                  sx={{ opacity: isDisabled ? 0.5 : 1 }}
                >
                  <InsertLinkOutlinedIcon />
                </IconButton>
              </TableCell>
            );
          }

          if (column.isChips) {
            if (column.tableName === "MERCHANT") {
              return (
                <TableCell key={index} component="th" scope="row">
                  <CustomChips
                    label={row[column.id]}
                    color={row[column.id] === "Enable" ? "primary" : "error"}
                    labelColor="primary"
                  />
                </TableCell>
              );
            }
          } else {
            if (column.id === "action" && isActionVisible) {
              return (
                <TableCell key={index} component="th" scope="row">
                  <MoreVertIcon
                    onClick={(e) => {
                      handleAction(e);
                      setSelectedData(row);
                    }}
                    sx={{ cursor: "pointer" }}
                  />
                </TableCell>
              );
            }
            return (
              <TableCell key={index} component="th" scope="row">
                {row[column.id]}
              </TableCell>
            );
          }
        })}
      </TableRow>
    </React.Fragment>
  );
}

function CustomTable({
  isShowRefreshButton,
  isExporteExcel,
  handleExportExcel,
  isExcelTemplateDownload,
  handleTemplateExcelDownload,
  selected,
  isShowCreateButton = true,
  setSelected,
  selectAll,
  setSelectAll,
  isShowAllDeleteBtn,
  handleAllDelete,
  handleRefreshClick,
  onSelect,
  isSelectioEnable = false,
  searchText,
  collapseTitle,
  innerTableHeaders,
  data,
  handlePrintInvoiceClick,
  isShowPrintInvoiceMenu,
  innerTableData,
  isShowExportCSV,
  handleExport,
  title,
  setSelectedData,
  isShowEditMenu,
  handleEditClick,
  isShowDeleteMenu,
  handleDelteClick,
  isShowChatMenu,
  handleChatClick,
  handleOnSearch,
  searchPlaceholder,
  createButtonName,
  columns,
  balance,
  isShowBalance,
  rowsPerPageOptions = [15, 25, 50],
  isActionVisible = true,
  isCollapse,
  isShowSearch = true,
  handleCreateClick,
  count,
  page,
  rowsPerPage,
  onRowsPerPageChange,
  onPageChange,
  handlePrintClick,
  isShowPrintMenu,
  isShowAssignBranger,
  handleAssignBrangerClick,
  isuploadexcel,
  handleUploadExcel,
  isMenuClicked = false,
  setIsMenuClicked,
}) {
  const isSmallScreen = useMediaQuery("(max-width:1100px)");
  const [anchorEl, setAnchorEl] = useState(false);
  const isMenuOpen = isMenuClicked ? null : anchorEl;
  const theme = useTheme();
  const [anchorSelectColumns, setAnchorSelectColumns] = useState(null);
  const [displayColumns, setDisplayColumns] = useState(columns);
  const [checkedColumns, setCheckedColumns] = useState(
    columns.reduce((acc, col) => ({ ...acc, [col.id]: true }), {})
  );
  const [anchorHeaderButtons, setAnchorHeaderButtons] = useState(null);

  useEffect(() => {
    if (isMenuClicked) {
      setIsMenuClicked(false);
      setAnchorEl(false);
    }
  }, [isMenuClicked]);

  const handleHeaderButtonsOpen = (event) => {
    setAnchorHeaderButtons(event.currentTarget);
  };

  const handleHeaderButtonsClose = () => {
    setAnchorHeaderButtons(null);
  };

  const handleMenuOpen = (event) => {
    setAnchorSelectColumns(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorSelectColumns(null);
  };

  const handleColumnToggle = (columnId) => {
    setCheckedColumns((prev) => {
      const updated = { ...prev, [columnId]: !prev[columnId] };
      setDisplayColumns(columns.filter((col) => updated[col.id]));
      return updated;
    });
  };

  const handleAction = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChangePage = (event, newPage) => {
    onPageChange(newPage + 1);
  };

  const handleChangeRowsPerPage = (event) => {
    onRowsPerPageChange(parseInt(event.target.value, 10));
    onPageChange(1);
  };

  const [displayedData, setDisplayedData] = useState([]);

  useEffect(() => {
    if (data) {
      setDisplayedData(data);
    }
  }, [data]);

  useEffect(() => {
    if (isSelectioEnable) {
      if (selected.length === displayedData.length) {
        setSelectAll(true);
      } else {
        setSelectAll(false);
      }
    }
  }, [selected, displayedData, isSelectioEnable]);

  useEffect(() => {
    if (isSelectioEnable) {
      setSelected([]);
      setSelectAll(false);
    }
  }, [displayedData?.length, isSelectioEnable]);

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = displayedData.map((item) => item.id);
      onSelect(newSelecteds);
      setSelected(newSelecteds);
      setSelectAll(true);
      return;
    }
    setSelected([]);
    setSelectAll(false);
    onSelect([]);
  };

  const handleClick = (event, id) => {
    const selectedIndex = selected?.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
    onSelect(newSelected);
  };

  const isSelected = (id) => selected?.indexOf(id) !== -1;

  return (
    <Box
      sx={
        {
          // boxShadow: 'rgba(0, 0, 0, 0.2) 0px 2px 10px 0px',
          // padding: "20px",
          // border: "20px solid #fff",
          // marginTop: "10px",
        }
      }
    >
      <Box
        sx={{ m: "0 0 20px", display: "flex", gap: "10px", flexWrap: "wrap" }}
      >
        {isShowSearch && (
          // <Grid item xl={3} lg={3} md={4} sm={4} xs={12}>
          <Box sx={{ p: "0", m: "0", maxWidth: "240px", width: "100%" }}>
            <CustomInput
              type="search"
              value={searchText}
              placeholder={searchPlaceholder}
              onChange={handleOnSearch}
            />
          </Box>
          // </Grid>
        )}
        {isShowBalance && (
          <Box>
            <Chip
              sx={{
                "& MuiChip-root": {
                  padding: "17px 0px !important",
                },
                backgroundColor: "#696cff29",
                padding: "22px 0px",
                borderRadius: "4px",
                marginBottom: "5px",
                fontSize: "20px",
                "& span": {
                  padding: "7px 10px",
                  color: "#696cff",
                },
              }}
              label={`Balance : ${balance}`}
            />
          </Box>
        )}
        <Box
          sx={{
            display: "flex",
            justifyContent: "end",
            gap: "10px",
            marginLeft: "auto",
          }}
        >
          {isSmallScreen ? (
            <>
              {/* Show Menu Button when screen size is less than 1100px */}
              <IconButton onClick={handleHeaderButtonsOpen}>
                <MoreVertIcon />
              </IconButton>
              <Menu
                anchorEl={anchorHeaderButtons}
                open={Boolean(anchorHeaderButtons)}
                onClose={handleHeaderButtonsClose}
              >
                {isuploadexcel && (
                  <MenuItem onClick={handleUploadExcel}>Upload CSV</MenuItem>
                )}
                {isExcelTemplateDownload && (
                  <MenuItem onClick={handleTemplateExcelDownload}>
                    Download CSV Template
                  </MenuItem>
                )}
                {isExporteExcel && (
                  <MenuItem onClick={handleExportExcel}>Export CSV</MenuItem>
                )}
                {isShowExportCSV && (
                  <MenuItem onClick={handleExport}>Export</MenuItem>
                )}
                {isShowRefreshButton && (
                  <MenuItem onClick={handleRefreshClick}>
                    <RefreshIcon sx={{ marginRight: "8px" }} /> Refresh
                  </MenuItem>
                )}
                {isShowCreateButton && (
                  <MenuItem onClick={handleCreateClick}>
                    {createButtonName}
                  </MenuItem>
                )}
                {isShowAllDeleteBtn && (
                  <MenuItem onClick={handleAllDelete} style={{ color: "red" }}>
                    Delete
                  </MenuItem>
                )}
                <MenuItem onClick={handleMenuOpen}>Select Columns</MenuItem>
                <Menu
                  anchorEl={anchorSelectColumns}
                  open={Boolean(anchorSelectColumns)}
                  onClose={handleMenuClose}
                >
                  <FormGroup sx={{ padding: 1 }}>
                    {columns.map((column) => (
                      <FormControlLabel
                        key={column.id}
                        control={
                          <Checkbox
                            checked={checkedColumns[column.id]}
                            onChange={() => handleColumnToggle(column.id)}
                          />
                        }
                        label={column.label}
                      />
                    ))}
                  </FormGroup>
                </Menu>
              </Menu>
            </>
          ) : (
            <>
              {/* Show All Buttons when screen size is greater than 1100px */}
              {isuploadexcel && (
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <CustomButton
                    style={{ marginRight: "10px" }}
                    buttonName="Upload CSV"
                    color="primary"
                    outline
                    onClick={handleUploadExcel} // Trigger file input click
                  />
                </Box>
              )}
              {isExcelTemplateDownload && (
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <CustomButton
                    style={{ marginRight: "10px" }}
                    buttonName="Download CSV Template"
                    color="primary"
                    outline
                    onClick={handleTemplateExcelDownload}
                  />
                </Box>
              )}
              {isExporteExcel && (
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <CustomButton
                    style={{ marginRight: "10px" }}
                    buttonName="Export CSV"
                    color="primary"
                    outline
                    onClick={handleExportExcel}
                  />
                </Box>
              )}
              {isShowExportCSV && (
                <CustomButton
                  style={{ marginRight: "10px" }}
                  buttonName="Export"
                  color="secondary"
                  outline
                  onClick={handleExport}
                />
              )}
              {isShowRefreshButton && (
                <CustomTooltip title="Refresh records">
                  <IconButton
                    sx={{
                      "& svg": { fill: "#fff !important" },
                      background: "#357a38",
                      whiteSpace: "nowrap",
                      "&:hover": {
                        backgroundColor: "#357a38 !important",
                      },
                    }}
                    onClick={handleRefreshClick}
                  >
                    <RefreshIcon />
                  </IconButton>
                </CustomTooltip>
              )}
              {isShowCreateButton && (
                <CustomButton
                  sx={{ whiteSpace: "nowrap" }}
                  buttonName={createButtonName}
                  color="primary"
                  onClick={handleCreateClick}
                />
              )}
              {isShowAllDeleteBtn && (
                <CustomButton
                  buttonName="Delete"
                  color="error"
                  onClick={handleAllDelete}
                />
              )}
              <CustomButton
                sx={{ whiteSpace: "nowrap", minWidth: "fit-content" }}
                style={{ marginRight: "10px" }}
                buttonName="Select Columns"
                color="primary"
                outline
                onClick={handleMenuOpen}
              >
                Select Columns
              </CustomButton>
              <Menu
                anchorEl={anchorSelectColumns}
                open={Boolean(anchorSelectColumns)}
                onClose={handleMenuClose}
              >
                <FormGroup sx={{ padding: 1 }}>
                  {columns.map((column) => (
                    <FormControlLabel
                      key={column.id}
                      control={
                        <Checkbox
                          checked={checkedColumns[column.id]}
                          onChange={() => handleColumnToggle(column.id)}
                        />
                      }
                      label={column.label}
                    />
                  ))}
                </FormGroup>
              </Menu>
            </>
          )}
        </Box>
      </Box>

      <Box
        sx={{
          overflow: "auto",
          border:
            theme.palette.mode === "dark"
              ? "1px solid #243E57"
              : "1px solid #f0f4fb",

          width: "100%",
        }}
      >
        <Table
          sx={{
            border: "0",
          }}
        >
          <TableHead
            sx={{
              "& th": {
                borderBottomColor:
                  theme.palette.mode === "dark" ? "#243E57" : "#dbdbeb1f",

                color: theme.palette.text.primary,
                borderTop:
                  theme.palette.mode === "dark"
                    ? "1px solid #243E57"
                    : "1px solid #dbdbeb1f",
                fontFamily: "Quicksand",
              },
            }}
          >
            <TableRow>
              {isSelectioEnable && displayedData?.length > 0 && (
                <TableCell>
                  <Checkbox
                    component="th"
                    scope="row"
                    indeterminate={
                      selected.length > 0 && selected.length < data.length
                    }
                    checked={selectAll}
                    onChange={handleSelectAllClick}
                  />
                </TableCell>
              )}
              {isCollapse && <TableCell />}
              {displayColumns.map((column) => (
                <TableCell
                  key={column.id}
                  sx={{
                    fontWeight: "600",
                    backgroundColor:
                      theme.palette.mode === "dark" ? "#243E57" : "#dfe3e8",
                    whiteSpace: "nowrap",
                    fontSize: "13px",
                    lineHeight: " 1",
                    padding: "15px",
                  }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody
            sx={{
              "& td,th": {
                fontFamily: "Quicksand",
                fontWeight: "500",
                color: "#666",
                borderBottomColor: "#dbdbeb1f",
                color: theme.palette.text.primary,
                textAlign: "center",
                "& svg": {
                  fill: theme.palette.text.primary,
                },
              },
            }}
          >
            {displayedData?.length === 0 ? (
              <TableRow>
                <TableCell colSpan={displayColumns?.length + 1}>
                  <Typography variant="body1" align="center">
                    No data available.
                  </Typography>
                </TableCell>
              </TableRow>
            ) : (
              displayedData.map((row, index) => (
                <Row
                  sx={{
                    "&:nth-child(2n+2)": {
                      "&:th": {
                        background: "red",
                      },
                    },
                  }}
                  isSelectioEnable={isSelectioEnable}
                  isSelected={isSelected}
                  handleClick={handleClick}
                  collapseTitle={collapseTitle}
                  innerTableHeaders={innerTableHeaders}
                  innerTableData={innerTableData}
                  index={index}
                  key={index}
                  setSelectedData={setSelectedData}
                  isActionVisible={isActionVisible}
                  columns={columns}
                  displayColumns={displayColumns}
                  handleAction={handleAction}
                  isCollapse={isCollapse}
                  row={row}
                />
              ))
            )}
          </TableBody>
        </Table>
      </Box>
      <TablePagination
        sx={{
          color: theme.palette.text.primary,
          "& .MuiTablePagination-selectIcon": {
            fill: "#dbdbebde",
          },
        }}
        rowsPerPageOptions={false}
        component="div"
        count={count}
        rowsPerPage={rowsPerPage}
        page={page - 1}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: "top", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        open={isMenuOpen}
        onClose={handleClose}
        sx={{
          "& .MuiMenu-paper": {
            minWidth: "130px",
            backgroundColor: theme.palette.background.paper,
            boxShadow:
              "rgba(0, 0, 0, 0.2) 0px 5px 6px -3px, rgba(0, 0, 0, 0.14) 0px 9px 12px 1px, rgba(0, 0, 0, 0.12) 0px 3px 16px 2px",
            color: theme.palette.text.primary,
          },
        }}
        MenuListProps={{
          "aria-labelledby": "lock-button",
          role: "listbox",
        }}
      >
        {isShowChatMenu && (
          <MenuItem onClick={handleChatClick}>
            <SmsIcon sx={{ width: "22px", marginRight: "8px" }} />
            Chat
          </MenuItem>
        )}

        {isShowEditMenu && (
          <MenuItem onClick={handleEditClick}>
            <EditIcon sx={{ width: "22px", marginRight: "8px" }} />
            Edit
          </MenuItem>
        )}

        {isShowPrintMenu && (
          <MenuItem onClick={handlePrintClick}>
            <PrintIcon sx={{ width: "22px", marginRight: "8px" }} />
            Print Label
          </MenuItem>
        )}

        {isShowAssignBranger && (
          <MenuItem onClick={handleAssignBrangerClick}>
            <AssignmentIndIcon sx={{ width: "22px", marginRight: "8px" }} />
            Assign Branger
          </MenuItem>
        )}

        {isShowPrintInvoiceMenu && (
          <MenuItem onClick={handlePrintInvoiceClick}>
            <ReceiptIcon sx={{ width: "22px", marginRight: "8px" }} />
            Print Invoice
          </MenuItem>
        )}

        {isShowDeleteMenu && (
          <MenuItem onClick={handleDelteClick}>
            <DeleteIcon sx={{ width: "22px", marginRight: "8px" }} />
            Delete
          </MenuItem>
        )}
      </Menu>
    </Box>
  );
}

export default CustomTable;
